import { Injectable } from '@angular/core';
import { Command, Random, StateService } from 'flux-core';
import { DataStore } from 'flux-store';
import { CreateDiagram } from './create-diagram.cmd';

/**
 * CreateDiagramWithAnonymousAccess to create diagram with anonymous access.
 */
@Injectable()
@Command()
export class CreateDiagramWithAnonymousAccess extends CreateDiagram {
    // Team diagram create command.
    constructor(
        protected random: Random,
        protected state: StateService<any, any>,
        protected dataStore: DataStore,
    ) {
        super( random, state, dataStore );
    }

    /**
     * This function will call the Create Diagram super class,
     * which adds the newly created diagram into Recent Diagrams
     * List.
     */
    public executeResult( response: any ): boolean {
        return super.executeResult( response );
    }
}

Object.defineProperty( CreateDiagramWithAnonymousAccess, 'name', {
    value: 'CreateDiagramWithAnonymousAccess',
});
